
notifications.factory('deviceHistoryResource', ['$resource', function ($resource) {
    return $resource('/devicesHistory/:action/:id', { action: '@action', id: '@id' }, {
        query: {
            isArray: false
        },
    });
}]);